"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutRegistration = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const _1 = require(".");
const composition_renderer_1 = require("./renderers/composition-renderer");
const compositions_renderer_1 = require("./renderers/compositions-renderer");
const middlewares_1 = require("./middlewares");
const components_renderer_1 = require("./renderers/components-renderer");
function LayoutRegistration() {
    return {
        registerComponents(registerCallback) {
            // the internal collection of registered components
            const registeredComponents = {};
            const componentMiddlewares = [];
            const builder = {
                registerComponent: registration => {
                    if (registeredComponents[registration.type]) {
                        throw new Error(`${registration.type} has already been registered`);
                    }
                    registeredComponents[registration.type] = registration;
                    return builder;
                },
                registerMiddleware: componentMiddleware => {
                    componentMiddlewares.push(componentMiddleware);
                    return builder;
                },
            };
            registerCallback({
                registerComponent: registration => {
                    if (registeredComponents[registration.type]) {
                        throw new Error(`${registration.type} has already been registered`);
                    }
                    registeredComponents[registration.type] = registration;
                    return builder;
                },
            });
            // the following exposes registerCompositions
            return {
                registerCompositions(registerCallback) {
                    const registeredCompositions = {};
                    const compositionMiddlewares = [];
                    const componentRegistrations = {
                        isRegistered(type) {
                            return registeredComponents[type] !== undefined;
                        },
                        get(type) {
                            const foundComponent = registeredComponents[type];
                            if (!foundComponent && process.env.NODE_ENV !== 'production') {
                                // continue rendering in production only. otherwise throw, this is so the site does not crash
                                // empty area will be rendered instead
                                console.warn({ type }, `Component has not been registered`);
                            }
                            return foundComponent;
                        },
                    };
                    const compositionRegistrations = {
                        get(type) {
                            const foundComposition = registeredCompositions[type];
                            if (!foundComposition && process.env.NODE_ENV !== 'production') {
                                // Warn a component is missing if not in production
                                console.warn({ type }, `Composition has not been registered`);
                            }
                            return foundComposition;
                        },
                    };
                    const { createRegisterableComponent } = _1.getRegistrationCreators();
                    const middlewares = {
                        component: () => null,
                        composition: () => null,
                    };
                    const layout = {
                        componentRegistrations,
                        compositionRegistrations,
                        component(component) {
                            return component;
                        },
                        composition(composition) {
                            return composition;
                        },
                        nestedComposition(composition) {
                            return {
                                type: 'nested-composition',
                                props: { composition: composition },
                            };
                        },
                        createRenderers({ services }) {
                            return {
                                renderComponents(...components) {
                                    return (react_1.default.createElement(components_renderer_1.ComponentsRenderer, { layoutApi: layout, componentMiddleware: middlewares.component, componentRegistrations: componentRegistrations, services: services, components: components, componentRenderPath: "", additionalComponentProps: {} }));
                                },
                                renderCompositions(...compositions) {
                                    return (react_1.default.createElement(compositions_renderer_1.CompositionsRenderer, { layoutApi: layout, componentMiddleware: middlewares.component, compositionMiddleware: middlewares.composition, componentRegistrations: componentRegistrations, compositionRegistrations: compositionRegistrations, services: services, compositions: compositions }));
                                },
                            };
                        },
                    };
                    builder.registerComponent(createRegisterableComponent('nested-composition', ({ composition, componentRenderPath, ...additionalComponentProps }, services) => {
                        if (composition.type === 'nested-composition') {
                            throw new Error("nested-composition is registered as a component, it is not allowed within a nested composition as it's not a composition, please check the route");
                        }
                        return (react_1.default.createElement(composition_renderer_1.CompositionRenderer, { composition: composition, componentRenderPath: `${componentRenderPath}nested:${composition.type}`, services: services, layoutApi: layout, componentRegistrations: componentRegistrations, compositionRegistrations: compositionRegistrations, componentMiddleware: middlewares.component, compositionMiddleware: middlewares.composition, additionalComponentProps: additionalComponentProps }));
                    }));
                    const compositionBuilder = {
                        registerComposition(registration) {
                            if (registeredCompositions[registration.type]) {
                                throw new Error(`${registration.type} has already been registered`);
                            }
                            registeredCompositions[registration.type] = registration;
                            return compositionBuilder;
                        },
                        registerMiddleware(compositionMiddleware) {
                            compositionMiddlewares.push(compositionMiddleware);
                            return compositionBuilder;
                        },
                    };
                    registerCallback(compositionBuilder);
                    middlewares.component = middlewares_1.composeMiddleware(componentMiddlewares);
                    middlewares.composition = middlewares_1.composeMiddleware(compositionMiddlewares);
                    return layout;
                },
            };
        },
    };
}
exports.LayoutRegistration = LayoutRegistration;
//# sourceMappingURL=LayoutRegistration.js.map